import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export enum BreakpointsEnum {
  mobile = 768,
  tablet = 1180,
}

export interface IScreen {
  isDesktop?: boolean;
  isTablet?: boolean;
  isMobile?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class ScreenService {
  width$ = new BehaviorSubject<number>(0);
  height$ = new BehaviorSubject<number>(0);
  screenMode$ = new BehaviorSubject<IScreen>({ isMobile: true });
  isMobile$: Observable<boolean> = this.screenMode$.asObservable().pipe(map((m) => !!m.isMobile));
  isDesktop$: Observable<boolean> = this.screenMode$.asObservable().pipe(map((m) => !!m.isDesktop));

  constructor() {

  }

  processWindowSize(width: number, height: number): void {
    const screenMode: IScreen = {
      isMobile: false,
      isTablet: false,
      isDesktop: false,
    };
    if (width < BreakpointsEnum.mobile) {
      screenMode.isMobile = true;
    } else if (width < BreakpointsEnum.tablet) {
      screenMode.isTablet = true;
    } else {
      screenMode.isDesktop = true;
    }

    this.screenMode$.next(screenMode);
    this.width$.next(width);
    this.height$.next(height);
  }
}
